import './PreferredBeneficiary.css'
import * as lang from "./lang.json";
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import {Input} from "@experta/commons-v2.input";
import {Select} from "@experta/commons-v2.select";
import { PreferredBeneficiaryInsure } from './utils';
import { useAppDispatch, useAppSelector } from '../../../Store/hooks';
import TrashIcon from '../../../Assets/Icons/trash-icon.svg';
import { getBeneficiaryRelationshipTypesAsync } from '../../../Store/BeneficiaryRelationshipTypes/actions';
/**
 * Interface used as props.
 * @name PreferredBeneficiaryInsuredFormProps
 */
export interface PreferredBeneficiaryInsuredFormProps {
    indexRoot?: number,
    preferredBeneficiaries: Array<PreferredBeneficiaryInsure>,
    onChange?: (data: Array<PreferredBeneficiaryInsuredForm>) => void
};

/**
 * Interface of beneficiary insured form.
 * @name PreferredBeneficiaryInsuredForm
 */
export interface PreferredBeneficiaryInsuredForm {
    name: string;
    lastname: string;
    dni: string;
    errorsMessages: Array<{ field: string, message: string }>;
};

/**
 * Main component.
 * @name BeneficiaryInsuredForm
 * @param {BeneficiaryInsuredFormProps}
 * @returns {<BeneficiaryInsuredForm />}
 */
const PreferredBeneficiaryInsuredForm = ({
    indexRoot = 0,
    preferredBeneficiaries,
    onChange = (data: Array<PreferredBeneficiaryInsuredForm>) => { }
}: PreferredBeneficiaryInsuredFormProps) => {
    const dispatch = useAppDispatch();

    const handleChange = (e: any, index: number) => {
        const newFormData = [...preferredBeneficiaries];
        (newFormData[indexRoot] as any)[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        onChange(newFormData);
    };

    useLayoutEffect(() => {
        (async () => {
            await dispatch(getBeneficiaryRelationshipTypesAsync());
        })();
    }, [dispatch])

    const hasError = (item: any, name: string) => {
        return item.errorsMessages.filter((el: any) => el.field === name).length > 0;
    };

    const getError = (item: any, name: string) => {
        if (hasError(item, name)) {
            return item.errorsMessages.filter((el: any) => el.field === name)[0].message;
        }
        else {
            return undefined;
        }
    };

    return (
        <div className="beneficiary-container mt-3">

            {preferredBeneficiaries && (
                <>
                    {preferredBeneficiaries.length > 0 && preferredBeneficiaries.map((item: PreferredBeneficiaryInsure, index: number) => (
                        <div className="row" key={index}>
                        <div className="col-md-4 col-12">
                            <Input
                                name="dni"
                                label={lang.insuredDni}
                                onChange={(e: any) => handleChange(e, index)}
                                value={item.dni}
                                type="text"
                                error={hasError(item, "dni")}
                                errorMessage={getError(item, "dni")}
                            />
                        </div>
                            <div className="col-md-4 col-12">
                                <Input
                                    name="name"
                                    label={lang.name}
                                    onChange={(e: any) => handleChange(e, index)}
                                    value={item.name}
                                    type="text"
                                    error={hasError(item, "name")}
                                    errorMessage={getError(item, "name")}
                                />
                            </div>
                            <div className={`${preferredBeneficiaries.length === 1 ? 'col-md-4' : 'col-md-2'} col-md-2 col-12`}>
                                <Input
                                    name="lastname"
                                    label={lang.lastname}
                                    onChange={(e: any) => handleChange(e, index)}
                                    value={item.lastname}
                                    type="text"
                                    error={hasError(item, "lastname")}
                                    errorMessage={getError(item, "lastname")}
                                />
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default PreferredBeneficiaryInsuredForm;
